import { TripPayment } from "../trips/trip.payment";
import { DailyCollectibleExpense } from "./daily.collectible.expense";

export class DailyCollectible{
    date: Date;
    payments: TripPayment[];
    expenses: DailyCollectibleExpense[];

    totalPayment: number;
    totalExpense: number;
    total: number;
}


// WEBPACK FOOTER //
// ./src/app/models/reports/daily.collectible.ts